import { store } from "@src/index";

import { leagueManagementActions } from "@features/leaguemgmt/leagueManagementSlice";

const loader = async () => {
    const leagues = store.getState().leaguemanagement.leagues;
    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getLeagues());

    await Promise.resolve(leaguesPromise);

    return {
        header: "MAJORYBL Leagues",
    };
};

export default loader;
